import { useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import {
  ClassLevelSubjectSettingApiResponse,
  ClassLevelSubjectSettingUpdatePayload,
} from "types/classLevelSubjectSettingTypes";
import { updateClassLevelSubjectSetting, createClassLevelSubjectSetting } from "services/classLevelSubjectSettingService";

export const useClassLevelSubjectSetting = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createItemClassLevelSubjectSetting = async (payload: {
    classLevelId: string;
    subjectId: string;
    numberHours: number;
  }) => {
    setLoading(true);
    try {
      const res = await createClassLevelSubjectSetting(payload);
      message.success(
        t("class_level_subject_setting.create_allowed_hours_success_message") ||
          "Class level subject setting created successfully"
      );
      setError(null);
      return res;
    } catch (err: any) {
      console.error(err);
      setError(err?.message || "Error creating class level subject setting");
      message.error(
        t("class_level_subject_setting.error_creating_allowed_hours") ||
          "Error creating class level subject setting"
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  const updateItemClassLevelSubjectSetting = async (
    settingId: string,
    payload: Partial<ClassLevelSubjectSettingUpdatePayload>
  ) => {
    setLoading(true);
    try {
      const res = await updateClassLevelSubjectSetting(settingId, payload);
      message.success(
        t("class_level_subject_setting.update_allowed_hours_success_message") ||
          "Class level subject setting updated successfully"
      );
      setError(null);
      return res;
    } catch (err: any) {
      console.error(err);
      setError(err?.message || "Error updating class level subject setting");
      message.error(
        t("class_level_subject_setting.error_updating_allowed_hours") ||
          "Error updating class level subject setting"
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    createItemClassLevelSubjectSetting,
    updateItemClassLevelSubjectSetting,
  };
};

export default useClassLevelSubjectSetting;
